import {FC} from 'react'
import {Row} from 'react-table'
import {Model} from '../../core/_models'
import clsx from 'clsx'

type Props = {
  row: Row<Model>
}

const CustomRow: FC<Props> = ({row}) => (
  <tr {...row.getRowProps()}>
    {row.cells.map((cell) => {
      return (
        <td
          {...cell.getCellProps()}
          className={clsx({'text-end min-w-100px': cell.column.id === 'actions'})}
          style={{padding:"8px"}}
        >
          {cell.render('Cell')}
        </td>
      )
    })}
  </tr>
)

export {CustomRow}

